// src/pages/EmailConfirmationPage.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './EmailConfirmationPage.css';
import SpeechIcon from "../components/SpeechIcon";

import {
  resendVerificationEmailData,
  reloadEmailVerificationStateData,
  getCurrentEmailConfirmationUserData,
} from '../services/emailConfirmationDataService';

import GateIcon from '../components/GateIcon';
import OfflineBanner from '../components/OfflineBanner';

function EmailConfirmationPage() {
  const navigate = useNavigate();
  const [resent, setResent] = useState(false);
  const [checking, setChecking] = useState(false);
  const [error, setError] = useState('');

  const [isOffline, setIsOffline] = useState(false);
  const [retryAttempt, setRetryAttempt] = useState(0);

  useEffect(() => {
    const checkConnection = async () => {
      try {
        await fetch("https://www.gstatic.com/firebasejs/9.6.1/firebase-app.js", {
          method: "HEAD",
          cache: "no-store",
        });

        setIsOffline(false);
      } catch (err) {
        console.warn("EmailConfirmationPage: Offline erkannt:", err);
        setIsOffline(true);
      }
    };

    checkConnection();
  }, [retryAttempt]);

  const handleOfflineRetry = () => {
    setIsOffline(false);
    setTimeout(() => setRetryAttempt((n) => n + 1), 600);
  };

  useEffect(() => {
    let isMounted = true;

    const interval = setInterval(async () => {
      try {
        const currentUser = await getCurrentEmailConfirmationUserData();

        if (!currentUser) {
          return;
        }

        const result = await reloadEmailVerificationStateData();

        if (!isMounted) return;

        if (result?.emailVerified) {
          clearInterval(interval);
          navigate('/login');
        }
      } catch (err) {
        console.warn("Polling-Fehler:", err);
      }
    }, 5000);

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [navigate]);

  const handleResend = async () => {
    setError('');
    setChecking(true);

    try {
      const currentUser = await getCurrentEmailConfirmationUserData();

      if (!currentUser) {
        setError("Bitte logge dich erneut ein, um die E-Mail erneut zu senden.");
        return;
      }

      await resendVerificationEmailData();
      setResent(true);
    } catch (err) {
      console.error("Fehler beim erneuten Senden der E-Mail:", err);
      setError("Fehler beim Senden. Bitte später erneut versuchen.");
    } finally {
      setChecking(false);
    }
  };

  return (
    <div className="EmailConfirmationPage">
      {isOffline && <OfflineBanner onRetry={handleOfflineRetry} />}

      <header className="header">
        <img
          src="/logo-edens-ernte-transparent.png"
          alt="Edens Ernte Logo"
          className="browse-logo"
          onClick={() => navigate('/')}
        />
        <p className="top-claim">Nachhaltigkeit – ganz einfach!</p>

        <GateIcon className="login-icon" />
        <SpeechIcon className="speech-icon no-tap-highlight" />
        <img
          src="/rezept-icon.png"
          alt="Rezepthelfer Icon"
          className="rezept-icon"
          onClick={() => navigate('/rezepte')}
        />
      </header>

      <div className="confirmation-box">
        <h2>Fast geschafft!</h2>
        <p>
          Bitte bestätige deine Registrierung über den Link, den wir dir gerade
          per E-Mail gesendet haben.
        </p>
        <p>Schau auch im Spam-Ordner nach.</p>

        {!resent && (
          <button
            className="green-button"
            onClick={handleResend}
            disabled={checking}
          >
            {checking ? 'Sende erneut...' : 'E-Mail erneut senden'}
          </button>
        )}

        {resent && <p style={{ color: 'green' }}>E-Mail wurde erneut gesendet.</p>}
        {error && <p style={{ color: 'red' }}>{error}</p>}
      </div>
    </div>
  );
}

export default EmailConfirmationPage;